import React, { useState, useEffect, useRef } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  useMap,
  FeatureGroup,
} from "react-leaflet";
import L from "leaflet";
import { EditControl } from "react-leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet/dist/leaflet.css";
import { useUpdateFarmByIdMutation } from "./farmerApiSlice";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";

const myIcon = L.icon({
  iconUrl: require("./marker4.jpg"),
  iconSize: [24, 35],
  iconAnchor: [12, 35],
  popupAnchor: [0, -35],
});

const MapController = ({ bounds }) => {
  const map = useMap();
  useEffect(() => {
    if (bounds) map.fitBounds(bounds);
  }, [bounds]);
  return null;
};

const FarmerCreateBoundary = ({ LandList, refetch, setCreateBoundary }) => {
  const [bounds, setBounds] = useState(null);
  const [updateFarm] = useUpdateFarmByIdMutation();
  const [loading, setLoading] = useState(false);
  const featureGroupRef = useRef(null);

  useEffect(() => {
    if (LandList?.boundary && LandList.boundary?.coordinates?.length) {
      const geoJson = {
        type: "Feature",
        geometry: LandList.boundary,
        properties: {},
      };

      const leafletGeoJsonLayer = L.geoJSON(geoJson);
      const newBounds = leafletGeoJsonLayer.getBounds();
      setBounds(newBounds);

      setTimeout(() => {
        const featureGroup = featureGroupRef.current;
        if (featureGroup) {
          featureGroup.clearLayers();
          leafletGeoJsonLayer.eachLayer((layer) => {
            layer.editing?.enable(); // Enable editing
            featureGroup.addLayer(layer);
          });
        }
      }, 0);
    }
  }, [LandList]);

  const handleSubmit = () => {
    const featureGroup = featureGroupRef.current;
    let coordinates = null;

    if (featureGroup) {
      const layers = featureGroup.getLayers().filter(
        (layer) => layer instanceof L.Polygon
      );

      if (layers.length === 0) {
        toast.error("No polygon drawn on the map");
        return;
      }

      const geoJson = layers[layers.length - 1].toGeoJSON();
      if (geoJson?.geometry?.coordinates?.length) {
        coordinates = geoJson.geometry.coordinates;
      }
    }

    if (!coordinates?.length) {
      toast.error("No valid boundary to save");
      return;
    }

    const payload = { coordinates };
    console.log("Submitting payload:", payload);

    setLoading(true);
    updateFarm({ id: LandList.id, payload })
      .unwrap()
      .then(() => {
        swal("Boundary Saved Successfully", {
          buttons: false,
          icon: "success",
          timer: 1500,
        });
        refetch();
        setCreateBoundary(false);
      })
      .catch(() => {
        toast.error("Failed to save boundary");
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <MapContainer center={[28, 72]} className="farmer_map" zoom={5}>
        <TileLayer
          url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}"
          attribution="&copy; OpenStreetMap contributors"
        />

        <FeatureGroup ref={featureGroupRef}>
          <EditControl
            position="topright"
            onCreated={(e) => {
              const featureGroup = featureGroupRef.current;
              featureGroup.clearLayers(); // Allow only one polygon at a time
              featureGroup.addLayer(e.layer);
            }}
            draw={{
              rectangle: false,
              polyline: false,
              circle: false,
              circlemarker: false,
              marker: false,
              polygon: true,
            }}
            edit={{
              featureGroup: featureGroupRef.current,
              edit: true,
              remove: true, // Allow deletion of old boundaries
            }}
          />
        </FeatureGroup>

        {!LandList?.boundary && LandList.latitude_1 && LandList.longitude_1 && (
          <Marker
            position={[+LandList.latitude_1, +LandList.longitude_1]}
            icon={myIcon}
          />
        )}

        <MapController bounds={bounds} />
      </MapContainer>

      <div>
        <button
          className="btn btn-success waves-effect mt-4"
          onClick={handleSubmit}
          disabled={loading}
        >
          Save Boundary &nbsp;{loading && <Spinner size="sm" />}
        </button>
      </div>
    </>
  );
};

export default FarmerCreateBoundary;
